<template>
  <div>

    <data-table
      :id="getTableRef()"
      :ref="getTableRef()"
      :title="title"
      :url="url"
      :table-ref="getTableRef()"
      :fields="fields"
      :hideTop="hideTop"
      :showSearch="showSearch"
      :org-badge="orgBadge"
      :showRefresh="showRefresh"
      :searchPlaceholder="searchPlaceholder"
      :add-action="(uploadInfo || uploadCallback) ? addFileAction : null"
      :add-props="addProps"
      :show-pagination="showPagination"
      :options="detailProps"
      detail-component="file-detail-row">

      <template #file-action="props">
        <el-form>
          <file-upload
            v-if="!props.rowData.url"
              :text="'Upload ' + props.rowData.title"

              :url="getEndpoint('/upload/' +
                props.rowData.id + '/site/' +
                props.rowData.site_id + '/' + userName())"

              :delete-file-only="true"
              :after-upload="uploaded"
              :after-delete="afterDelete"
              :model="getModel(props.rowData.id)"
              type="primary"
              :show-tooltip="true"
              :size="size"
              :additional-data="uploadInfo"
              :disabled="isViewOnly() || disableUpload(props.rowData)">
          </file-upload>

          <div v-else>
              <el-button
                :type="getType(props.rowData)"
                  @click="download(props.rowData)"
                  :size="size"
                  :disabled="isViewOnly()">
                  <b>Download {{props.rowData.title}}</b>
                </el-button>
                <p v-if="showFileName && isDesktop"><small>
                  <i>{{props.rowData.name}}</i>
                </small></p>
            </div>
          </el-form>
      </template>

    </data-table>

  </div>
</template>


<script>
import Vue from 'vue'

import PostMixins from '@/mixins/PostMixins'
import ArrayMixins from '@/mixins/ArrayMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import FileAction from '@/components/actions/FileAction'

import FileDetails from '@/components/tables/details/FileDetails'

import FileUpload from '@/components/atoms/files/FileUpload'
import FileDownload from '@/components/atoms/files/FileDownload'

Vue.component('file-detail-row', FileDetails)

export default {
  mixins: [PostMixins, ArrayMixins, DateMixins, NumberMixins],

  components: {
    FileAction,
    FileDownload,
    FileUpload
  },

  props: {
    siteId: {
      type: Number,
      default: null
    },

    type: {
      type: String,
      default: null
    },

    typeId: {
      type: Number,
      default: null
    },

    step: {
      type: Number,
      default: null
    },

    partyNo: {
      type: Number,
      default: null
    },

    stepData: {
      type: Object,
      default: null
    },

    orgBadge: {
      type: Object,
      default: null
    },

    title: {
      type: String,
      default: 'Files'
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    showFileName: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Search'
    },

    uploadInfo: {
      type: Object,
      default: null
    },

    uploadCallback: {
      type: Function,
      default: null
    },

    disableForm: {
      type: Boolean
//      default: false
    },

    tableRef: {
      type: String,
      default: 'filestable'
    },

    showPagination: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    }
  },

  computed: {
    url: function () {
      return '/files/' + (this.siteId
        ? 'site/' + this.siteId + '/' + this.type : this.type) +
         (this.typeId ? '/' + this.typeId : '') +
         (this.step ? (this.siteId ? '/' : '/null/null/') + this.step + (this.partyNo ? '/' + this.partyNo : '')
        : (this.siteId ? '/null' : '/null/null') + (this.partyNo ? '/' + this.partyNo : ''))
    }
  },

  watch: {
    stepData (value) {

      if (this.addProps.copyExisting && value && value.stepNo) {
        this.addProps.copyExisting.step = value.stepNo
        this.addProps.copyExisting.partyNo = this.partyNo
      }
    }
  },

  methods: {
    getTableRef () {
      return this.tableRef + '-' + (this.partyNo ? this.partyNo : this.rand)
    },

    formatKiloBytes (value) {
      if (value && value > 0) {
        return '<b>' + this.formatInteger(value / 1000) + '</b>k'
      } else {
        return ''
      }
    },

    filler (value) {
      return '<span style="width: 100%; color: transparent;">' + value + '</span>'
    },

    refreshTable () {
      this.$events.emit(this.getTableRef() + '-refresh-table')
    },

    getModelKey (id) {
      return this.getTableRef() + 'Upload' + id
    },

    getModel (id) {
      var key = this.getModelKey(id)
      var arr = this.key(key, this.fileUploads)

      if (arr) {
        return arr
      } else {
        this.fileUploads.push({[key]: []})
        return this.key(key, this.fileUploads)
      }
    },

    clearModel (id) {
      var key = this.getModelKey(id)
      var arr = this.key(key, this.fileUploads)

      if (arr) {
        arr = []
        this.fileUploads.push({[key]: []})
      }
    },

    getType (row) {
      return row.approved
          ? 'success' : row.downloaded
          ? 'info' : (row.state && row.state.status === 'Rejected' ? 'danger' : 'warning')
    },

    disableUpload (row) {
      if (this.stepData && this.stepData.stepNo) {
        return !(row.step === this.stepData.stepNo && row.partyNo === this.stepData.partyNo)
      } else {
        return false
      }
    },

    uploaded (file, fileList) {
      this.refreshTable()
      fileList = []

      if (this.uploadCallback) {
        this.uploadCallback(file, this.uploadInfo)
      }

    },

    download (row) {
      var dwUrl = this.getEndpoint('file/download/' + row.url + '/' + row.name)
      this.downloadFile(dwUrl)

      row.downloaded = true
      row.lastDownload_at = this.formatDateTimeSql(new Date())
      row.lastDownload_by = this.userName()
      this.saveForm(this, '/file', row.id, row, 'File Details', null, null, false)
    },

    afterDelete (data = null) {

      if (data) {

        this.fileData.url = null
        this.fileData.downloaded = false

        this.clearModel(data.id)
      }

      this.refreshTable()
    },

    info (rowData, stepNo) {

      var data = {
        info: {},
        sendTo: []
      }

      if (rowData && rowData.state && rowData.emails) {

        var prop = this.isTelco() ? 'tower' : 'telco'

        if (!rowData.emails[prop]) {
          console.error('OLD FORMAT for state.emails:', rowData.emails)
        } else {
          for (var i = 0; i < rowData.emails[prop].length; i++) {
            if (rowData.emails[prop][i] && !data.sendTo.includes(rowData.emails[prop][i])) {
              data.sendTo.push(rowData.emails[prop][i])
            }
          }

        }

        data.info.step = stepNo
        data.info.sendMail = rowData.emails.sendMail ? rowData.emails.sendMail : false
        data.info.rts_id = rowData.id ? rowData.id : null
        data.info.site_id = rowData.site_id ? rowData.site_id : null
        data.info.towerCoName = this.xolasClient().name ? this.xolasClient().name : 'Xolas Towers'
        data.info.email = this.xolasClient().email ? this.xolasClient().email : 'support@xolas.io'
        data.info.phone = this.xolasClient().phone ? this.xolasClient().phone : null
        data.info.siteName = rowData.site && rowData.site.siteName ? rowData.site.siteName : 'No Site Selected'
        data.info.siteId = rowData.site && rowData.site.siteId ? rowData.site.siteId : 'N/A'
        data.info.telcoSiteId = rowData.site && rowData.site.telcoSiteId ? rowData.site.telcoSiteId : 'N/A'
        data.info.sharerName = rowData.organisation && rowData.organisation.name ? rowData.organisation.name : 'No Sharer Selected'
      }
    }
  },

  data () {
    return {
      rand: null,
      fileData: this.rowData,

      detailProps: {
        disableForm: this.disableForm
      },

      addFileAction: FileAction,

      addProps: {
        showCaption: false,
        showRef: false,
        tableRef: this.getTableRef(),

        copyExisting: {
          site_id: this.siteId,
          workflow_id: this.workflow_id,
          typeKey: this.siteId ? 'site' : this.type,
          type_id: this.siteId ? this.siteId : this.typeId,
          processKey: this.siteId ? this.type : null,
          process_id: this.siteId ? this.typeId : null,
          step: this.step,
          seqNo: this.stepData ? this.stepData.seqNo : null,
          partyNo: this.partyNo ? this.partyNo : (this.stepData ? this.stepData.partyNo : null)
        }

      },
      fileUploads: [],
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: '__slot:file-action',
          title: 'File'
        },
        {
          name: 'upload_by',
          title: '',
          callback: this.filler,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'size',
          title: 'Size',
          callback: this.formatKiloBytes,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down u-pull-right'
        }
      ]
    }
  },  // data

  created () {
//    console.log('type', this.type, 'typeNo', this.typeId, 'stepNo', this.step, 'partyNo', this.partyNo)
    this.rand = (this.rand ? this.rand : this.randBetween())

    this.addProps.tableRef = this.getTableRef()
  }
}

</script>

<style scoped>
a {text-decoration: none;}
</style>
